const WP_JSON = (path: string) =>
  `${process.env.REACT_APP_WP_URL}/wp-json/wm-subscription/v1/subscription/${path}`

export function getWordPressAuthPageUrl(): string {
  return `${process.env.REACT_APP_WP_URL}/my-account/`
}

export type CleverMapCheckResult =
  | { needsAuthRedirect: true }
  | { needsAuthRedirect: false; hasCleverMapAccess: boolean }

function parseCheckPayload(result: Record<string, unknown> | null | undefined): CleverMapCheckResult {
  if (!result || typeof result !== 'object') {
    return { needsAuthRedirect: false, hasCleverMapAccess: false }
  }
  const raw = result['success'] ?? result['status']
  if (raw === '0') {
    return { needsAuthRedirect: true }
  }
  if (raw === '1') {
    return { needsAuthRedirect: false, hasCleverMapAccess: true }
  }
  return { needsAuthRedirect: false, hasCleverMapAccess: false }
}

export async function checkCleverMapSubscriptionFromWebapp(
  refreshToken: string,
  idToken: string,
): Promise<CleverMapCheckResult> {
  try {
    const response = await fetch(WP_JSON('check_from_webapp'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        RefreshToken: refreshToken,
        ID: idToken,
        token: process.env.REACT_APP_WP_TOKEN,
      }),
    })
    if (!response.ok) {
      return { needsAuthRedirect: false, hasCleverMapAccess: false }
    }
    const result = (await response.json()) as Record<string, unknown>
    return parseCheckPayload(result)
  } catch {
    return { needsAuthRedirect: false, hasCleverMapAccess: false }
  }
}


export function redirectToWordPressAuthPage(): void {
  window.location.href = getWordPressAuthPageUrl()
}

function openInNewTab(url: string): boolean {
  const w = window.open(url, '_blank', 'noopener,noreferrer')
  return w !== null
}

export async function startCleverMapSubscriptionFromWebapp(
  refreshToken: string,
  idToken: string,
): Promise<{ url?: string } | null> {
  const unsuccessUrl = `${process.env.REACT_APP_WP_URL}/my-account/`
  try {
    const response = await fetch(WP_JSON('new_from_webapp'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        RefreshToken: refreshToken,
        ID: idToken,
        token: process.env.REACT_APP_WP_TOKEN,
      }),
    })
    if (!response.ok) {
      if (!openInNewTab(unsuccessUrl)) window.location.href = unsuccessUrl
      return null
    }
    const result = await response.json()
    if (result?.url) {
      if (!openInNewTab(result.url)) {
        window.location.href = result.url
      }
      return result
    }
    if (!openInNewTab(unsuccessUrl)) window.location.href = unsuccessUrl
    return null
  } catch {
    if (!openInNewTab(unsuccessUrl)) window.location.href = unsuccessUrl
    return null
  }
}
